<template>
<div id="contents" v-if="grid_layout_status == 'grid_list_show' && modal_show == false && modal_change == false">

  <div id="post_main">
    <div class="post_modal_window">
      <div id="grid_list" :class="['grid_margin_' + choice_tag]">
        <div class="post_container">

          <div class="list_wrapper" v-for="(grid_list, index) in grid_all_lists" :key="index" v-show="modal_show == false && post_type == 'all'">
            <div class="left_list">
              <div v-for="(post, index) in grid_list.left_list"
                :key="index"
                :class="[grid_layout_status] + ' grid_list item ' + [index < 2 ? 'tmb_medium' : 'tmb_large' ]"
                @click="open_model(post.post_id, post.layout, post.link)"
                :style="{
                  'animation-duration': 1.2 - index / 10 + 's',
                  'animation-delay': 0.2 + index / 10 + 's'
                }">
                <h2 class="title" v-if="post.layout != 'program' && post.tag != '採用ムービー'" :class="title_color(post.layout)" >
                  <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                </h2>
                <img v-if="post.layout != 'players'" :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                <img v-else :src="post.kv_image" width="286" alt="番組のロゴ" class="hover players_kv" />
              </div>
            </div>

            <div class="right_list">
              <div v-for="(post, index) in grid_list.right_list"
                :key="index"
                :class="[grid_layout_status] + ' grid_list item tmb_small ' + [ thumbnail_style(post.layout) ? 'text_small' : '' ]"
                @click="open_model(post.post_id, post.layout, post.link)" 
                :style="{
                  'animation-duration': 1.2 - index / 10 + 's',
                  'animation-delay': 0.2 + index / 10 + 's'
                }">
                <div class="program_image_area" v-if="post.layout == 'program'">
                  <img :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                </div>
                <div class="image_area" v-else >
                  <img v-if="post.layout != 'players'" :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                  <img v-else :src="post.kv_image" width="286" alt="番組のロゴ" class="hover players_kv" />
                </div>
                <div class="text_area small" v-if="thumbnail_style(post.layout)">
                  <h2 class="title" :class="title_color(post.layout)">
                    <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                  </h2>
                </div>
                <div class="text_area" v-else-if="post.layout != 'program'">
                  <h2 class="title" :class="title_color(post.layout)">
                    <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                  </h2>
                </div>
              </div>
            </div>
            <div :id="'add_grid_list_target_' + index " style="position: absolute, bottom: 0"></div>
          </div>

          <div class="list_wrapper" v-for="(grid_list, index) in grid_lists" :key="index" v-show="modal_show == false && post_type != 'all'">
            <div class="left_list">
              <div v-for="(post, index) in grid_list.left_list"
                :key="index"
                :class="[grid_layout_status] + ' grid_list item ' + [index < 2 ? 'tmb_medium' : 'tmb_large' ]"
                @click="open_model(post.post_id, post.layout, post.link)"
                :style="{
                  'animation-duration': 1.2 - index / 10 + 's',
                  'animation-delay': 0.005 + index / 10 + 's'
                }">
                <h2 class="title" v-if="post.layout != 'program' && post.tag != '採用ムービー'" :class="title_color(post.layout)">
                  <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                </h2>
                <img v-if="post.layout != 'players'" :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                <img v-else :src="post.kv_image" width="286" alt="番組のロゴ" class="hover players_kv" />
              </div>
            </div>

            <div class="right_list">
              <div v-for="(post, index) in grid_list.right_list"
                :key="index"
                :class="[grid_layout_status] + ' grid_list item tmb_small ' + [ thumbnail_style(post.layout) ? 'text_small' : '' ]"
                @click="open_model(post.post_id, post.layout, post.link)" 
                :style="{
                  'animation-duration': 1.2 - index / 10 + 's',
                  'animation-delay': 0.005 + index / 10 + 's'
                }">
                <div class="program_image_area" v-if="post.layout == 'program'">
                  <img :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                </div>
                <div class="image_area" v-else >
                  <img v-if="post.layout != 'players'" :src="post.kv_image" width="286" alt="番組のロゴ" class="hover kv" />
                  <img v-else :src="post.kv_image" width="286" alt="番組のロゴ" class="hover players_kv" />
                </div>
                <div class="text_area small" v-if="thumbnail_style(post.layout)">
                  <h2 class="title" :class="title_color(post.layout)">
                    <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                  </h2>
                </div>
                <div class="text_area" v-else-if="post.layout != 'program'">
                  <h2 class="title" :class="title_color(post.layout)">
                    <p v-for="(name, index) in post.name" :key="index">{{ name }}</p>
                  </h2>
                </div>
              </div>
            </div>
            <div :id="'add_grid_list_target_' + index " style="position: absolute, bottom: 0"></div>
          </div>

        </div>
      </div>
    </div>
  </div>

</div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_tags',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/recruit/recruit_2023.php',
      api_players_url: this.$parent.api_base_url+'/api/players/index.php',
      api_program_url: this.$parent.api_base_url+'/api/program/index.php',
      api_top_program_url: this.$parent.api_base_url+'/api/top/top_program.php',
      api_request_post_url: this.$parent.api_base_url+'/api/recruit/recruit_2023_request_post.php',
      api_base_url: this.$parent.api_base_url,
      loading: false,
      grid_lists: [],
      grid_lists_size: null,
      get_grid_list: [],
      past_get_grid_list: [],
      grid_all_lists: [],
      grid_list: null,
      players_list: null,
      top_program_list: null,
      recruit_2021_list: null,
      all_players_list: [],
      all_top_program_list: null,
      all_recruit_2021_list: null,
      error: null,
      modal: false,
      moving_speed: 12,
      back_btn: "back_hidden",
      request_layout: "",
      list_show_status: 'list_show',
      add_grid_timeout: false,
      add_grid_list_count: null,
      fetch_all_list_timeout: false,
      before_num: [],
      first_grid_lists: true,
      slice_players_list: [],
      slice_top_program_list: [],
      slice_recruit_2021_list: [],
      add_grid_list_stop: false,
    }
  },
  props: [
    'choice_tag',
    'grid_layout_status',
    'modal_show',
    'modal_change',
    'post_type',
    'api',
    'request_id'
  ],
  watch: {
    grid_layout_status: function(){
      if ( this.grid_layout_status == 'grid_list_show' ){
        this.first_grid_lists = true
        this.grid_lists_size = null
        this.add_grid_list_count = 0
        this.grid_lists = []
        this.get_grid_list = []
        if( this.post_type == 'all'){
          if( this.grid_all_lists.length == 0){
            this.fetch_players_list(30)
            this.fetch_players_list(31)
            this.fetch_players_list(27)
            this.fetch_players_list(32)
            this.fetch_top_program_list(0)
            this.fetch_recruit_2021_list(null, null)
          } else {
            this.grid_all_lists = []
            this.fetch_all_list( this.all_players_list, this.all_top_program_list, this.all_recruit_2021_list )
          }
        } else if ( this.api == "players") {
          if (this.request_id == 0 && this.all_players_list){
            this.get_grid_list = []
            this.get_grid_list = this.get_grid_list.concat(this.all_players_list)
            for (let i = 0; i < this.get_grid_list.length; i++) {
              if ([8010, 8697, 7678].includes(this.get_grid_list[i].post_id)) {
                this.get_grid_list.splice(i--, 1);
              }
            }
            this.slice_grid_list()
          } else {
            this.fetch_players_list(this.request_id)
          }
        } else if ( this.api == "program") {
          if( this.request_id == 0){
            this.fetch_top_program_list(this.request_id)
          } else{
            this.fetch_program_list(this.request_id)
          }
        } else {
          this.fetch_recruit_2021_list(this.post_type, this.request_id)
        }
      } else {
        this.grid_lists = []
        this.get_grid_list = []
      }
    }
  },
  mounted () {
    this.fetch_players_list(30)
    this.fetch_players_list(31)
    this.fetch_players_list(27)
    this.fetch_players_list(32)
    this.fetch_top_program_list(0)
    this.fetch_recruit_2021_list(null, null)
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  created() {
    window.addEventListener('scroll', this.add_grid_list)
  },
  destroyed() {
    window.removeEventListener('scroll', this.add_grid_list)
  },
  methods: {
    open_model(post_id, layout, link) {
      this.$emit('modal_show', post_id, layout, link);
    },
    close_model() {
      this.$emit('modal_show');
    },
    grid_list_reload(post_type){
      var post_type = post_type.shift()
      this.$emit('request_post_type', post_type);
    },
    fetch_players_list(request_id){
      this.$axios
        .get(this.api_players_url,{
          params: {
            term_id: request_id
          }
        })
        .then(response => {
          this.get_grid_list = response.data.item
          if(request_id == 0){
            for (let i = 0; i < this.get_grid_list.length; i++) {
              if ([8010, 8697, 7678].includes(this.get_grid_list[i].post_id)) {
                this.get_grid_list.splice(i--, 1);
              }
            }
          }
          for ( var i = 0; i < this.get_grid_list.length; i++ ) {
            this.get_grid_list[i]['layout'] = "players"
            var name = this.get_grid_list[i]['name']
            this.get_grid_list[i]['name'] = []
            if (request_id == 30){
              this.get_grid_list[i]['name'].push('プロデューサー');
            } else if (request_id == 31) {
              this.get_grid_list[i]['name'].push('総合演出');
            } else if (request_id == 27) {
              this.get_grid_list[i]['name'].push('ディレクター');
            } else if (request_id == 32) {
              this.get_grid_list[i]['name'].push('カメラマン');
            }
            this.get_grid_list[i]['name'].push(name);
          }
          if (this.post_type == "all"){
            this.all_players_list = this.all_players_list.concat(this.get_grid_list)
          } else {
            this.slice_grid_list(this.get_grid_list)
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    fetch_program_list(request_id){
      this.$axios
        .get(this.api_program_url,{
          params: {
            term_id: request_id
          }
        })
        .then(response => {
          this.get_grid_list = response.data.item
          for ( var i = 0; i < this.get_grid_list.length; i++ ) {
            this.get_grid_list[i]['layout'] = "program"
          }
          this.slice_grid_list()
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    fetch_top_program_list(){
      this.$axios
        .get(this.api_request_post_url,{
          params: {
            category: 'top_program',
          }
        })
        .then(response => {
          this.get_grid_list = response.data.item
          for ( var i = 0; i < this.get_grid_list.length; i++ ) {
            this.get_grid_list[i]['layout'] = "program"
          }
          if (this.post_type == "all"){
            this.all_top_program_list = this.get_grid_list
          } else {
            this.slice_grid_list()
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    fetch_recruit_2021_list(post_type, request_id){
      this.$axios
        .get(this.api_url,{
          params: {
            post_type: post_type
          }
        })
        .then(response => {
          this.get_grid_list = response.data.item
          for ( var i = 0; i < this.get_grid_list.length; i++ ) {
            this.get_grid_list[i].name.split('<p>').join('')
            this.get_grid_list[i].name = this.get_grid_list[i].name.split('<p>').join('')
            this.get_grid_list[i].name = this.get_grid_list[i].name.split('</p>').join('*')
            this.get_grid_list[i].name = this.get_grid_list[i].name.split('*');
            this.get_grid_list[i].name.pop();
          }
          if (request_id != null){
            this.fetch_request_post_list(request_id)
          } else if (this.post_type == "all"){
            this.all_recruit_2021_list = this.get_grid_list
            for(var i in this.all_recruit_2021_list){
              if([9170, 9467, 9468].includes(this.all_recruit_2021_list[i].id) ){
                this.all_recruit_2021_list.splice(i--, 1);
              }
            }
            this.get_grid_list = []
            clearTimeout( this.fetch_all_list_timeout );
            this.fetch_all_list_timeout = setTimeout(() => {
              this.fetch_all_list( this.all_players_list, this.all_top_program_list, this.all_recruit_2021_list )
            }, 500)
          } else {
            this.slice_grid_list()
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    fetch_request_post_list(request_id){
      this.$axios
        .get(this.api_request_post_url,{
          params: {
            request_id: request_id
          }
        })
        .then(response => {
          for ( var i = 0; i < response.data.item.length; i++ ) {
            if (this.post_type == 'drone'){
              response.data.item[i]['layout'] = "players"
              response.data.item[i]['name'] = ['カメラマン', response.data.item[i]['name']]
            } else {
              if (response.data.item[i]['layout'] == false){
                response.data.item[i]['layout'] = "pink"
              }
              response.data.item[i]['name'] = [response.data.item[i]['name']]
            }
          }
          this.get_grid_list = this.get_grid_list.concat(response.data.item)
          this.slice_grid_list()
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    list_shuffle(post_list){
      for(var list_size = post_list.length - 1; list_size > 0; list_size--){
        var r = Math.floor(Math.random() * (list_size + 1));
        var tmp = post_list[list_size];
        post_list[list_size] = post_list[r];
        post_list[r] = tmp;
      }
      return post_list
    },
    slice_all_list(slice_post_list, post_list, slice_size ,post_type){
      if (slice_post_list.length < slice_size && this.first_grid_lists == false && post_type == 'recruit_2021'){
        this.add_grid_list_stop = true
      } else {
        if(slice_post_list.length < slice_size ){
          slice_post_list = []
          slice_post_list = slice_post_list.concat(post_list)
          var past_post_id_list = []
          for(var i in this.past_get_grid_list){
            if (this.past_get_grid_list[i].id == undefined){
              past_post_id_list.push(this.past_get_grid_list[i].post_id)
            } else {
              past_post_id_list.push(this.past_get_grid_list[i].id)
            }
          }
          // for(var i in slice_post_list){
          //   if(past_post_id_list.includes(slice_post_list[i].id) ){
          //     slice_post_list.splice(i--, 1);
          //   }
          //   if(past_post_id_list.includes(slice_post_list[i].post_id) ){
          //     slice_post_list.splice(i--, 1);
          //   }
          // }
        }
      }
      this.get_grid_list = this.get_grid_list.concat(this.list_shuffle(slice_post_list).slice(0, slice_size));
      slice_post_list.splice(0, slice_size)
      return slice_post_list
    },
    fetch_all_list(players_list, top_program_list, recruit_2021_list){
      this.past_get_grid_list = []
      this.past_get_grid_list = this.past_get_grid_list.concat(this.get_grid_list)
      this.get_grid_list = [];
      if (this.first_grid_lists == false ){
        this.slice_players_list = this.slice_all_list(this.slice_players_list, players_list, 1, 'players')
        this.slice_top_program_list = this.slice_all_list(this.slice_top_program_list, top_program_list, 2, 'top_program')
        this.slice_recruit_2021_list = this.slice_all_list(this.slice_recruit_2021_list, recruit_2021_list, 4, 'recruit_2021')
      } else {
        this.slice_recruit_2021_list = []
        this.slice_recruit_2021_list = this.slice_recruit_2021_list.concat(recruit_2021_list)
        this.slice_players_list = this.slice_all_list(this.slice_players_list, players_list, 1, 'players')
        this.slice_top_program_list = this.slice_all_list(this.slice_top_program_list, top_program_list, 1, 'top_program')
        this.slice_recruit_2021_list = this.slice_all_list(this.slice_recruit_2021_list, recruit_2021_list, 2, 'recruit_2021')
        for(var i in this.slice_recruit_2021_list){
          if([9170, 9467, 9468].includes(this.slice_recruit_2021_list[i].id) ){
            this.slice_recruit_2021_list.splice(i--, 1);
          }
        }
      }
      for(var list_size = this.get_grid_list.length - 1; list_size > 0; list_size--){
        var r = Math.floor(Math.random() * (list_size + 1));
        var tmp = this.get_grid_list[list_size];
        this.get_grid_list[list_size] = this.get_grid_list[r];
        this.get_grid_list[r] = tmp;
      }
      var grid_list = [];
      grid_list['left_list'] = this.get_grid_list.slice(0,3);
      if (this.first_grid_lists){
        for(var i in this.get_grid_list){
          if([9170, 9467, 9468].includes(this.get_grid_list[i].id) ){
            this.get_grid_list.splice(i--, 1);
          }
        }
        grid_list['right_list'] = this.get_grid_list.slice(3,4)
        var company_post = {"post_id":"","name":["会社のコト"],"post_type":"","link":"","tag":"会社のコト","layout":"company","kv_image":"https:\/\/www.tv-asahipro.co.jp\/wp-content\/uploads\/2020\/01\/company.png","kv_image_type":"normal"}
        var welfare_post = {"post_id":"","name":["福利厚生と働く環境"],"post_type":"welfare","link":"","tag":"福利厚生と働く環境","layout":"welfare","kv_image":"https:\/\/www.tv-asahipro.co.jp\/wp-content\/uploads\/2020\/03\/teaching-e1583916364211.png","kv_image_type":"normal"}
        var program_this_and_that_post = {"post_id":"","name":["番組制作のあれこれ"],"post_type":"program_this_and_that","link":"","tag":"番組制作のあれこれ","layout":"point","kv_image":"https:\/\/www.tv-asahipro.co.jp\/wp-content\/uploads\/2020\/01\/program_this_and_that_3.png","kv_image_type":"normal"}
        grid_list['right_list'].unshift(welfare_post)
        grid_list['right_list'].unshift(program_this_and_that_post)
        grid_list['right_list'].unshift(company_post)
        this.first_grid_lists = false
      } else {
        grid_list['right_list'] = this.get_grid_list.slice(3,7);
      }
      this.grid_all_lists.push(grid_list);
    },
    thumbnail_style(layout){
      if (['players', 'creator-agency', 'company', 'drone', 'photographing', 'movie', 'point' ,'rorando', 'welfare', 'working_environment', 'top_message', 'corona', 'galaxy_award' ].includes(layout)){
        return true
      }
    },
    title_color(layout){
      if(['players', 'program', 'creator-agency', 'company', 'drone', 'photographing', 'link' ,'pink' ,'rorando', 'welfare', 'working_environment', 'top_message', 'corona', 'galaxy_award'].includes(layout) ){
        layout = 'pink'
      }
      return {
        pink: layout == 'pink',
        blue: layout == 'movie',
        purple: layout == 'young',
        yellow: layout == 'point',
        deep_blue: layout == 'pinch',
      }
    },
    slice_grid_list(get_grid_list){
      if (this.grid_lists_size == null){
        this.grid_lists_size = Math.ceil(this.get_grid_list.length / 7)
      }
      var grid_list = [];
      grid_list['left_list'] = this.get_grid_list.slice(0,3);
      grid_list['right_list'] = this.get_grid_list.slice(3,7);
      this.get_grid_list.splice(0, 7)
      this.grid_lists.push(grid_list);
    },
    add_grid_list(){
      if (this.add_grid_list_count != null && this.modal_show == false && this.add_grid_list_stop == false) {
        clearTimeout( this.add_grid_timeout ) ;
        if ( this.post_type == 'all' || this.grid_lists_size >= (this.add_grid_list_count + 2)) {
          this.add_grid_timeout = setTimeout(() => {
            var t = $('#add_grid_list_target_' + this.add_grid_list_count).offset().top;
            var p = t - $(window).height();
            if($(window).scrollTop() > p){
              if( this.post_type == 'all'){
                this.fetch_all_list( this.all_players_list, this.all_top_program_list, this.all_recruit_2021_list )
              } else {
                this.slice_grid_list(this.get_grid_list)
              } 
              this.add_grid_list_count++
            }else{
            }
          }, 100)
        }
      }
    }
  },
}
</script>

<style scoped lang="sass">
@keyframes tag_slide_in
  0%
    display: block
  100%
    transform: translateY(0vw)

@keyframes tag_hidden
  0%
    opacity: 1
  20%
    opacity: 0
  21%
    transform: translateY(0vw)
  100%
    opacity: 0
    transform: translateY(100vw)
@keyframes tag_open
  0%
    opacity: 0
    transform: translateY(0vw)
  100%
    opacity: 1

@keyframes tag_in_bound
  0%
    transform: translateY(100vw)
  12%
    transform: translateY(89.11vw)
  24%
    transform: translateY(56.22vw)
  36%
    transform: translateY(1.99vw)
  54%
    transform: translateY(24.98vw)
  74%
    transform: translateY(1.63vw)
  82%
    transform: translateY(6.25vw)
  92%
    transform: translateY(0.66vw)
  96%
    transform: translateY(1.54vw)
  100%
    transform: translateY(0vw)

@keyframes tag_choice
  0%
    width: auto
  100%
    top: 6.2vw
    left: 2.1vw
    width: auto
@keyframes tag_choice_text
  0%
  80%
    font-size: 5.1vw
  100%
    font-size: 5.1vw
@keyframes tag_return
  0%
    top: 6.2vw
    left: 2.1vw
    width: auto
  100%
@keyframes tag_return_text
  0%
    font-size: 5.1vw
  100%

#recruit_header
  position: absolute
  top: 1.4vw
  left: 2.1vw
  height: 1.4vw
  .tv-asahi_logo
    width: 14.4vw
    height: 1.9vw
  .recruit_2021_logo
    width: 10.1vw
    height: 1.5vw
  .entry_btn
    top: 1.4vw
    left: 72.6vw
    width: 8.6
    height: 2.2vw
    background: #F5FF00 0% 0% no-repeat padding-box
    border-radius: 19px
    text-align: center
    font-size: 14px
    letter-spacing: 0.7px
    color: #FF7689
  .requirements_btn
    width: 121px
    height: 31px
    background: #FFFFFF 0% 0% no-repeat padding-box
    border-radius: 19px
    text-align: center
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: 14px
    letter-spacing: 2.76px
    color: #FF7689

.slide_in
  animation-name: tag_slide_in
  animation-fill-mode: forwards
  transform: translateY(70vw)

.choice
  animation-name: tag_choice
  animation-fill-mode: forwards
  animation-delay: 0s !important
  p
    animation-name: tag_choice_text
    animation-fill-mode: forwards
    animation-duration: 0.5s
    animation-delay: 0s !important

.show
  animation-name: tag_open
  animation-fill-mode: forwards
  animation-delay: 0s !important
  opacity: 0

.hidden
  animation-name: tag_hidden
  animation-fill-mode: forwards
  animation-duration: 0.2s
  animation-delay: 0s !important

.return
  animation-name: tag_return
  animation-fill-mode: forwards
  animation-duration: 2s
  animation-delay: 0s !important
  p
    animation-name: tag_return_text
    animation-fill-mode: forwards
    animation-duration: 0.5s
    animation-delay: 0s !important

@keyframes back_show
  0%
    opacity: 0
  100%
    opacity: 1
@keyframes back_hidden
  0%
    opacity: 1
  100%
    opacity: 0

.back_btn
  position: absolute
  top: 7.3vw
  left: 90.2vw
  font-family: 'Noto Sans JP', sans-serif
  font-weight: 700
  font-size: 1.6vw
  color: #FFF
  cursor: pointer
.back_show
  animation-name: back_show
  animation-fill-mode: forwards
  animation-duration: 2s
.back_hidden
  animation-name: back_hidden
  animation-fill-mode: forwards
  animation-duration: 1s

@keyframes grid_list_show
  0%
  100%
    transform: translateY(0vh)
@keyframes grid_list_hidden
  0%
    transform: translateY(0vh)
  100%
    transform: translateY(100vh)

.grid_list
  transform: translateY(100vh)
.grid_list_show
  animation-name: grid_list_show
  animation-fill-mode: forwards
  animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1)
.grid_list_hidden
  animation-name: grid_list_hidden
  animation-fill-mode: forwards
  animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1)
  animation-delay: 0s !important

#contents
  width: 100vw
  background-color: #ff7689
  min-height: 100vh
  overflow: hidden
.tag_list
  max-height: 56.9vw
  overflow: hidden
  position: relative
  &_item
    width: 5%
    display: flex
    position: absolute
    p
      font-family: 'Noto Sans JP', sans-serif
      font-weight: 700
      line-height: 1
      color: #FFF
      display: block
      white-space: nowrap
      cursor: pointer

.post_container
  width: 96.2vw
  padding-bottom: calc(2.4vw + 41px)
  margin: 0 1.7vw 0 2.1vw
  position:relative
  .list_wrapper
    position: relative
    margin-bottom: 5vw
  &:after
    clear: both
    display: block
    content: ""
  .left_list
    width: 89.6vw
    margin: 0 auto
    .tmb_medium
      width: 100%
      height: 50.4vw
      &:nth-child(2)
        margin-top: 19px
    .tmb_large
      float: left
      width: 100%
      height: 50.4vw
      margin-top: 19px
    .title
      position: absolute
      bottom: 16px
      font-family: 'Noto Sans JP', sans-serif
      font-size: 19px
      line-height: 25px
      font-weight: 700
      p
        padding: 0 3px 0 8px
        background: #fff
        border: 1px solid #FFF
        display: table
        margin-top: 3px
    .pink
      padding: 0 3px 0 0px
      display: inline-block
      margin-top: 3px
    .tag
      position: absolute
      top: 10px
      right: 11px
      font-family: 'Noto Sans JP', sans-serif
      background: #FF7689
      color: #fff
      font-size: 8px
      font-weight: 700
      line-height: 2.1
      display: inline-block
      border-radius: 30px
      padding: 0 9px
      cursor: pointer
  .right_list
    width: 89.6vw
    margin: 0 auto
    margin-bottom: 6px
    display: flex
    flex-wrap: wrap
    align-items: stretch
    .tmb_small
      height: 44vw
      width: 48.5%
      margin-top: 17px
      display: inline-block
      &:nth-child(odd)
        margin-right: 3%
      &:nth-child(n+3)
        margin-top: 10px
    .tmb_small.text_small
      min-height: 130px
    .text_area
      padding: 8px 0 0 9px
      height: 20.5vw
      background: #fff
      position: relative
      .title
        font-size: 13px
        font-weight: 700
        line-height: 19px
        width: 100%
        p
          display: table
          font-family: 'Noto Sans JP', sans-serif
          line-height: 19px
      .pink
        display: inline-block
        font-family: 'Noto Sans JP', sans-serif
        &:not(:first-child)
          margin-top: 3px
      .tag
        background: #FF7689
        color: #fff
        font-size: 8px
        font-weight: 700
        line-height: 2.1
        display: inline-block
        border-radius: 30px
        padding: 0 9px
        font-family: 'Noto Sans JP', sans-serif
        cursor: pointer
    .text_area.small
      padding: 0 9px 0 9px
      min-height: 30px
      display: flex
      align-items: center
      .title
        margin: 13px 0
        line-height: 13px

  .item
    border-radius: 8px
    overflow: hidden
    position: relative
    background-color: #fff
    .program_image_area
      height: 44vw
      width: 44vw
      overflow: hidden
      position: relative
      img
        position: absolute
        z-index: -10
        width: 101%
        top: 50%
        left: 50%
        -webkit-transform: translate(-50%, -50%)
        transform: translate(-50%, -50%)
    .image_area
      height: 23.5vw
      overflow: hidden
      position: relative
    img
      position: absolute
      z-index: -10
      width: 101%
    .players_kv
      top: 50%
      left: 50%
      -webkit-transform: translate(-50%, -95%)
      transform: translate(-50%, -95%)

#post
  &_main
    .post_modal_window
      .post_modal
        &_overlay
          display: flex
          align-items: center
          justify-content: center
          position: fixed
          overflow: scroll
          z-index: 30
          top: 0
          left: 0
          width: 100%
          height: 100%
          z-index: 1000
          background: rgba(0, 0, 0, 0.5)
        &_window
          background: #fff
          border-radius: 4px
          overflow: hidden
          height: 90%
        &_content
          height: 100%
          overflow: scroll

      .post_modal-enter-active, .post_modal-leave-active
        transition: opacity 0.4s
        .post_modal_window
          transition: opacity 0.4s, transform 0.4s

      .post_modal-leave-active
        transition: opacity 0.6s ease 0.4s
      .modal-enter, .modal-leave-to
        opacity: 0

        .post_modal
          &_window
            opacity: 0
            transform: translateY(-20px)
          &_mask
            position: fixed
            z-index: 1000
            top: 0
            left: 0
            width: 100%
            height: 100%
            background-color: rgba(0, 0, 0, .5)
            display: table
            transition: opacity .3s ease

          &_wrapper
            display: table-cell
            vertical-align: middle

          &_container
            width: 300px
            margin: 0px auto
            padding: 20px 30px
            background-color: #fff
            border-radius: 2px
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33)
            transition: all .3s ease

.pink
  color: #FF7689
.blue
  color: #02ACC3
.purple
  color: #8B53AF
.yellow
  color: #FFBA00
.deep_blue
  color: #003A6F

.post_modal
  &_body
    margin: 20px 0
  &_default-button
    float: right
  &-enter
    opacity: 0
  &-leave-active
    opacity: 0

.fade-enter-active, .fade-leave-active
  transition: opacity 1s
.fade-enter, .fade-leave-to
  opacity: 0
@media screen and (max-width: 374px)
  .post_container
    .list_wrapper
    &:after
    .left_list
      .tmb_medium
        &:nth-child(2)
      .tmb_large
      .title
        p
      .pink
      .tag
    .right_list
      .tmb_small
        &:nth-child(odd)
        &:nth-child(n+3)
      .tmb_small.text_small
        min-height: 114px
      .text_area
        padding: 3px 0 0 9px
        .title
          p
        .pink
          &:not(:first-child)
        .tag
      .text_area.small
        .title
          font-size: 12px
  
</style>



// WEBPACK FOOTER //
// src/components/recruit_grid_list.vue